import { DeviceInfo } from '@capacitor/device'
import { ICurrentUser } from './user.meta.model'

export class ResetUserStateAction {
  public static readonly type = '[UserMeta] Reset to Initial State'
  constructor() {}
}

export class SetCurrentUserAction {
  public static readonly type = '[UserMeta] Set Current User'
  constructor(public payload: ICurrentUser) {}
}

export class SetAcceptTermsAction {
  public static readonly type = '[UserMeta] Set Accept Terms'
  constructor(public payload: boolean) {}
}
export class SetShowControlAction {
  public static readonly type = '[UserMeta] Set Show Control'
  constructor(public payload: boolean) {}
}

export class SetUserImage {
  public static readonly type = '[UserMeta] Set User Image'
  constructor(public payload: any) {}
}

export class SetUserFiles {
  public static readonly type = '[UserMeta] Set User Files'
  constructor(public payload: any[]) {}
}

export class SetUserDeviceInfo {
  public static readonly type = '[UserMeta] Set User Device Info'
  constructor(public payload: DeviceInfo) {}
}
